import { render, staticRenderFns } from "./ItemImageInput.vue?vue&type=template&id=3176d58c&scoped=true&"
import script from "./ItemImageInput.vue?vue&type=script&lang=js&"
export * from "./ItemImageInput.vue?vue&type=script&lang=js&"
import style0 from "./ItemImageInput.vue?vue&type=style&index=0&id=3176d58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3176d58c",
  null
  
)

export default component.exports